import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import * as fromSelectors from '../../../entities/providers/selectors';

import { PriceStyled } from './styled';

import { useTranslation } from '../../../i18n';

import { getPriceDifference, priceCurrencyToSign } from '../../../helpers/currency';

const formatDiscount = (num: number): string => {
  const fixed = num.toFixed(2);

  return fixed.endsWith('.00') ? Math.round(num).toString() : fixed;
};

export const Price: React.FC<{ price: string; priceDiscount?: string; discount?: number | null }> = ({
  price,
  priceDiscount,
  children,
  discount,
}) => {
  const [t] = useTranslation('rates');

  const difference: string | null = useMemo(() => (priceDiscount ? getPriceDifference(price, priceDiscount) : null), [
    price,
    priceDiscount,
  ]);

  const realPrice: string = discount && priceDiscount ? priceDiscount : price;

  return (
    <>
      <PriceStyled>
        {discount && (
          <p>
            {t('rates.services.sale')} {formatDiscount(discount)}% ({difference})
          </p>
        )}
        {children}
        <span>{priceCurrencyToSign(realPrice)}</span>
        {discount && <em>{price}</em>}
        <br />
        {t('rates.services.perParcel')}
      </PriceStyled>
    </>
  );
};

export const ParcelPrice: React.FC = () => {
  const price = useSelector(fromSelectors.getParcelPrice);
  const discountPrice = useSelector(fromSelectors.getParcelDiscountPrice);
  const discount = useSelector(fromSelectors.getParcelDiscount);

  return (
    <div hidden={!price}>
      <Price price={price} priceDiscount={discountPrice} discount={discount} />
    </div>
  );
};
